import React from 'react';
import styled from 'styled-components';

import { Spin, Title } from 'components';

const SavingLoader = () => (
  <StyledContainer>
    <Title level={2}> Saving Contact</Title>
    <Spin size="large" />
  </StyledContainer>
);

export default SavingLoader;

const StyledContainer = styled.div`
  display: grid;
  grid-gap: 10px;
  align-items: center;
  justify-items: center;
  padding: 20px;
`;
